import Splide from '@splidejs/splide';
import './article-media-slider.scss';

// Riquadro delle slide principali: 3:2 (tcl-picture--cover).
// Le immagini con rapporto larghezza/altezza fra MIN e MAX (4:3, 3:2, 16:9…) lo riempiono
// ritagliate come sempre; le altre (verticali, quadrate, panoramiche) si vedono intere.
const RAPPORTO_RIQUADRO = 3 / 2;
const RAPPORTO_MIN_RITAGLIO = 1.25;
const RAPPORTO_MAX_RITAGLIO = 1.9;
// Comportamento attivo solo con questa classe su <html> (nel bundle: etichetta GALLERY_IMMAGINI_INTERE,
// vedi default_head); senza, tutte le slide restano ritagliate come prima.
const CLASSE_IMMAGINI_INTERE = 'a70-gallery-immagini-intere';

/**
 * version    1.0
 * class      ArticleMediaSlider
 * classdesc  Gestisce la galleria immagini dell’articolo:
 *            - slider principale
 *            - slider thumbnails sincronizzato
 */
export class ArticleMediaSlider {
  constructor() {
    this.gallery = document.querySelector('.dettaglio-articolo-media');
    if (!this.gallery) return;

    this.mainEl = this.gallery.querySelector('#article-main-slider');
    this.thumbEl = this.gallery.querySelector('#article-thumb-slider');

    if (!this.mainEl || !this.thumbEl) return;

    this.init();
  }

  init() {
    // Evita doppia inizializzazione
    if (this.mainEl.classList.contains('is-initialized')) return;

    const sharedOptions = {
      height: 'auto',
      gap: '.5rem',
    };

    this.mainSplide = new Splide(this.mainEl, {
      ...sharedOptions,
      perPage: 1,
      classes: {
        pagination: 'splide__pagination col-10',
      },
      breakpoints: {
        767: {
          classes: {
            pagination: 'splide__pagination col-8',
          },
        },
      },
    });

    this.thumbSplide = new Splide(this.thumbEl, {
      ...sharedOptions,
      perPage: 4,
      arrows: false,
      pagination: false,
      isNavigation: true,
      dragMinThreshold: {
        mouse: 4,
        touch: 10,
      },
      breakpoints: {
        992: { perPage: 4 },
        991: { perPage: 2 },
        768: { perPage: 2 },
        767: { perPage: 1 },
      },
    });

    this.mainSplide.sync(this.thumbSplide);

    this.thumbSplide.mount();
    this.mainSplide.mount();

    if (!document.documentElement.classList.contains(CLASSE_IMMAGINI_INTERE)) return;

    // Formato delle slide principali: noto solo a immagine caricata (lazysizes)
    this.mainEl.addEventListener('lazyloaded', (e) => this.adattaFormato(e.target));
    this.mainEl.querySelectorAll('.tcl-picture__image.lazyloaded').forEach((img) => this.adattaFormato(img));
  }

  adattaFormato(img) {
    const picture = img.closest('.tcl-picture--cover');
    if (!picture || !img.naturalWidth || !img.naturalHeight) return;

    const rapporto = img.naturalWidth / img.naturalHeight;
    if (rapporto >= RAPPORTO_MIN_RITAGLIO && rapporto <= RAPPORTO_MAX_RITAGLIO) return;

    picture.classList.add(rapporto < RAPPORTO_RIQUADRO
      ? 'tcl-picture--adatta-altezza'
      : 'tcl-picture--adatta-larghezza');
  }
}
